import React, {useEffect, useState} from 'react';
import * as ValgTypes from '../Store/Valg/Types';
import { StamdataUtlandHelgradModel } from '../Models/StamdataUtlandHelgradModel';
import * as UtregningUtland from '../Utilities/Utregning'
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import UtdanningValg from '../Utilities/UtdanningTypeValg';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface UtregningAProps {
    tittelUtregning: JSX.Element | null,
    satser: StamdataUtlandHelgradModel | null,
    valg: ValgTypes.ValgState,
    valutaBenevnelseUtregning: string,
    stipendVilkarTekst: JSX.Element | null,
    stipendTittelUtregning: JSX.Element | null,
    lanTittelUtregning: JSX.Element | null,
    tekstForLanOgStipendSomAlleFaar: JSX.Element | null,
    tekstForDeMedSkolepenger: JSX.Element | null,
    tekstForDeMedSkolepengerOgTilleggsstipend: JSX.Element | null,
    tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan: JSX.Element | null,
    tekstForDeMedSkolepengerOgTilleggslan: JSX.Element | null,
    resTekstAlleOgRekruttering: JSX.Element | null;
    resTekstSkolepengerRekruttering: JSX.Element | null;
    resTekstSkolepengerUtvidetstipendRekruttering: JSX.Element | null;
    resTekstSkolepUtvidetstipendUtvidetlanRekruttering: JSX.Element | null;
    resTekstSkolepengerUtvidetlanRekruttering: JSX.Element | null;
    vilkarStudieStotteLenkeTekst: JSX.Element | null,
    vilkarStudieStotteTittel: JSX.Element | null,
    vilkarStudieStotteTekst: JSX.Element | null,
    vilkarLukkStudieStottePopupAriaTekst: string,
    visUtbetalingsPlanHandler: any,
    utbetalingsPlanLenkeTekst: JSX.Element | null,
    profesjonUnntakOppsummering: any,
    locale:string
}

export default function UtregningA(props: UtregningAProps): JSX.Element {
    const [visVilkarAModal, setVisVilkarAModal] = useState(false);
    const [visUtbetalingsplan, setVisUtbetalingsplan] = useState(false);

    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }
    useEffect(() => {
        updateLiveMessage();
    }, []);

    function onVisUtbetalingsPlan(): void {
        if(visUtbetalingsplan) {
            setVisUtbetalingsplan(false);
            props.visUtbetalingsPlanHandler(false);
        } else {
            setVisUtbetalingsplan(true);
            props.visUtbetalingsPlanHandler(true);
        }
    }

    function profesjonsTekstregel() : JSX.Element | null{
        if(props.valg.aUtdanning?.value === UtdanningValg.a4_profesjon) {
            return <p className="c-veileder__tekst">{props.profesjonUnntakOppsummering}</p>;
        }
        return null;
    }

    const erTildeltRekrutteringsstipend: boolean = UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser) > 0;

    function hentYtelsesBeskrivelseTekst(): JSX.Element | null {

        if (props.valg.dSkolepenger == undefined) return null;
        if (props.satser == undefined) return null;

        let skoleKostnad: number = parseInt(props.valg.dSkolepenger.value.replace(/\s/g, ''));

        //hvis D1 < ID6 og D1 > 0
        if(skoleKostnad < props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR && skoleKostnad > 0) {
            if (erTildeltRekrutteringsstipend) {
                return <span>{props.resTekstSkolepengerRekruttering}</span>;
            } else {
                return <span>{props.tekstForDeMedSkolepenger}</span>;
            }
        }

        //hvis D1 < ID6+ID10 og E1=ja 
        if(skoleKostnad < props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR
            && UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg)) {
            if (erTildeltRekrutteringsstipend) {
                return <span>{props.resTekstSkolepengerUtvidetstipendRekruttering}</span>;
            } else {
                return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipend}</span>;
            }
        }

        //hvis D1 > ID6+ID10 og E1=ja
        if(skoleKostnad > props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR
            && UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg)) {
            if (erTildeltRekrutteringsstipend) {
                return <span>{props.resTekstSkolepUtvidetstipendUtvidetlanRekruttering}</span>;
            } else {
                return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan}</span>;
            }
        }

        //hvis D1 > ID6 og E1=nei
        if(skoleKostnad > props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR
            && !UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg)) {
            if (erTildeltRekrutteringsstipend) {
                return <span>{props.resTekstSkolepengerUtvidetlanRekruttering}</span>;
            } else {
                return <span>{props.tekstForDeMedSkolepengerOgTilleggslan}</span>;
            }
        }

        if (erTildeltRekrutteringsstipend) {
            return <span>{props.resTekstAlleOgRekruttering}</span>;
        } else {
            return <span>{props.tekstForLanOgStipendSomAlleFaar}</span>;
        }
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                        {props.tittelUtregning}
                    </h3>
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst">
                        <span>{UtregningUtland.formatNumber(
                            UtregningUtland.regnUtBasisLan(props.valg, props.satser).totaltStipendOgLan + 
                            UtregningUtland.regnUtReiseStotte(props.valg, props.satser).totaltStipendOgLan + 
                            UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).totaltStipendOgLan +
                            UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser), props.locale
                            )}</span>
                        {/* <span>{formatNumber(regnUtBasisLan().totaltStipendOgLan + regnUtReiseStotte().totaltStipendOgLan + regnUtSkolepengerStotte().totaltStipendOgLan)}</span> */}
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valutaBenevnelseUtregning}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        {hentYtelsesBeskrivelseTekst()}
                    </p>
                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel-row-top-space">
                <div className="c-veileder__content">
                    {profesjonsTekstregel()}
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{props.stipendTittelUtregning}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>{UtregningUtland.formatNumber(
                            UtregningUtland.regnUtBasisLan(props.valg, props.satser).stipendKroner + 
                            UtregningUtland.regnUtReiseStotte(props.valg, props.satser).stipendKroner + 
                            UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner +
                            UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser), props.locale
                            )}</span>
                        {/* <span>{formatNumber(regnUtBasisLan().stipendKroner + regnUtReiseStotte().stipendKroner + regnUtSkolepengerStotte().stipendKroner)}</span> */}
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valutaBenevnelseUtregning}</span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        <span>{props.stipendVilkarTekst}</span>
                    </p>

                </div>
            </div>
            <div className="c-veileder__panel-row c-veileder__panel-row-bottom-space">
                <div className="c-veileder__content c-veileder__content--header"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{props.lanTittelUtregning}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>{UtregningUtland.formatNumber(UtregningUtland.regnUtBasisLan(props.valg, props.satser).lanKroner + UtregningUtland.regnUtReiseStotte(props.valg, props.satser).lanKroner + UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).lanKroner, props.locale)}</span>
                        {/* <span>{formatNumber(regnUtBasisLan().lanKroner + regnUtReiseStotte().lanKroner + regnUtSkolepengerStotte().lanKroner)}</span> */}
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valutaBenevnelseUtregning}</span>
                    </div>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarAClick}>
                        {props.vilkarStudieStotteLenkeTekst}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarAModal}
                        onRequestClose={onRequestLukkVilkarA}
                        ariaCloseText={props.vilkarLukkStudieStottePopupAriaTekst}
                    >
                        <ArticleContentComponent
                            headerinnhold={props.vilkarStudieStotteTittel}
                            contentinnhold={props.vilkarStudieStotteTekst}
                        />
                    </ModalCompontent>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit" onClick={onVisUtbetalingsPlan}>{props.utbetalingsPlanLenkeTekst}</button>
                </div>
            </div>
        </div>
    )

}